import React, {Dispatch, SetStateAction} from 'react'
import style from './style.less'
import SearchBar from '../SearchBar'
import DateRangePicker from 'rsuite/DateRangePicker'
import {predefinedRanges} from '../../helpers/dateRangePicker'
import startOfDay from 'date-fns/startOfDay'
import endOfDay from 'date-fns/endOfDay'
import {FormControl, InputLabel, MenuItem, Select, SelectChangeEvent} from '@mui/material'
import {FormattedMessage, useIntl} from 'react-intl'

interface dateRange {
  sessionStart: string | undefined
  sessionEnd: string | undefined
}

export interface SearchFilterProps {
  setSearchQuery: Dispatch<SetStateAction<string>>
  setDateRange: Dispatch<SetStateAction<dateRange | null>>
  licenseId?: string
  setLicenseId?: Dispatch<SetStateAction<string>>
  showLicenseFilter?: boolean
  licenseOptions?: Array<{ value: string, label: string }>
}

const SearchFilter = ({
  setSearchQuery,
  setDateRange,
  licenseId = '',
  setLicenseId,
  showLicenseFilter = false,
  licenseOptions = [],
}: SearchFilterProps) => {
  const intl = useIntl();

  const handleLicenseChange = (e: SelectChangeEvent<string>) => {
    setLicenseId?.(e.target.value);
  };

  return (
    <div className={style.searchContainer}>
      <SearchBar
        fullWidth
        clear
        placeholder={intl.formatMessage({ id: 'search_drives' })}
        setSearchQuery={setSearchQuery}
      />
      <div className={style.filtersContainer}>
        {showLicenseFilter && setLicenseId && licenseOptions.length > 0 && (
          <div className={style.licenseFilterContainer}>
            <FormControl size="small" style={{ minWidth: 200 }}>
              <InputLabel id="license-filter-label"><FormattedMessage id={'license_type'} /></InputLabel>
              <Select
                labelId="license-filter-label"
                value={licenseId}
                label={<FormattedMessage id={'license_type'} />}
                onChange={handleLicenseChange}
                className={style.licenseSelect}
              >
                <MenuItem value=""><FormattedMessage id={'all_licenses'} /></MenuItem>
                {licenseOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        )}
        <div className={style.datePickerContainer}>
          <DateRangePicker
            character={'-'}
            size="lg"
            ranges={predefinedRanges}
            placeholder={intl.formatMessage({ id: 'filter_by_date' })}
            placement={'bottomEnd'}
            onChange={(value: any | null) => {
              if (value && (value[0] || value[1])) {
                document.querySelector('#gridContainer')?.scrollTo(0, 0)
                setDateRange({
                  sessionStart: startOfDay(value[0]).toISOString(),
                  sessionEnd: endOfDay(value[1]).toISOString(),
                })
              }
            }}
            onClean={() => {
              setDateRange(null)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default SearchFilter
